export function initHeader() {
  const header = document.querySelector(".site-header");
  const toggle = document.querySelector(".menu-toggle");
  const nav = document.querySelector(".nav");
  const items = [...document.querySelectorAll(".nav-item")];

  const onScroll = () => {
    header?.classList.toggle("is-scrolled", window.scrollY > 12);
  };

  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  const closeMegas = (except) => {
    items.forEach((item) => {
      const button = item.querySelector(".mega-toggle");
      const mega = item.querySelector(".mega");
      if (!button || !mega || item === except) return;
      mega.classList.remove("is-open");
      button.setAttribute("aria-expanded", "false");
    });
  };

  const setMenuOpen = (open) => {
    if (!nav || !toggle) return;
    nav.classList.toggle("is-open", open);
    header?.classList.toggle("is-nav-open", open);
    document.body.classList.toggle("nav-open", open);
    toggle.setAttribute("aria-expanded", String(open));
    toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    if (!open) closeMegas();
  };

  toggle?.addEventListener("click", () => {
    setMenuOpen(!nav.classList.contains("is-open"));
  });

  nav?.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => setMenuOpen(false));
  });

  items.forEach((item) => {
    const button = item.querySelector(".mega-toggle");
    const mega = item.querySelector(".mega");
    if (!button || !mega) return;
    button.addEventListener("click", (event) => {
      event.preventDefault();
      const willOpen = !mega.classList.contains("is-open");
      closeMegas(item);
      mega.classList.toggle("is-open", willOpen);
      button.setAttribute("aria-expanded", String(willOpen));
    });
  });

  document.addEventListener("click", (event) => {
    if (nav?.classList.contains("is-open")) return;
    if (items.some((item) => item.contains(event.target))) return;
    closeMegas();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    closeMegas();
    setMenuOpen(false);
  });
}
